/*
 * MDB shim for MDBToastContainer
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/PurchaseQueue/ServicePartList.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 */

import { Fragment } from "react";

/*
 * Non-obvious mapping note:
 * This is intentionally a no-op placeholder until app wiring moves to a concrete toast provider.
 */
export default function MDBToastContainer() {
    return <Fragment />;
}
